import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { NavigationMenu } from '@plataforma/components';
import UserMenu from '@plataforma/components/src/components/UserMenu';
import { ClausesAPI } from '@services/api';
import { forceDownload } from '@plataforma/utils';
import _ from 'lodash';
import { useRemoteConfig } from '../../../../context/RemoteConfigContext';
import {
  MainText,
  MiddleText,
  AlignItens,
  StyledHeader,
  SmallerText,
  StyledRadioButton,
  SelectModality,
  SelectCoverage,
  Button
} from './styles';
import ClausesModal from './ClausesModal';

function ClausesWrapper({ callbackMenu }) {
  const [remoteState] = useRemoteConfig();
  const [options, setOptions] = useState([]);
  const [radioValue, setRadioValue] = useState(8);
  const [selectedModality, setSelectedModality] = useState(null);
  const [selectedSubmodality, setSelectedSubmodality] = useState(null);
  const [subOptions, setSubOptions] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [generalCondition, setGeneralCondition] = useState(null);
  const [particularConditions, setParticularConditions] = useState(null);
  const [specialCondition, setSpecialCondition] = useState(null);
  const getUser = () => {
    const broker = JSON.parse(localStorage.getItem('broker')) || {};
    return broker.user ? broker.user : null;
  };

  useEffect(() => {
    async function fetchModality(insuredType) {
      const data = await ClausesAPI.returnedModality(insuredType);
      const mappedOptions = data?.map(option => ({
        label: option.description,
        id: option.id,
        value: option.id,
        subModalities: option.subModalities
      }));
      setOptions(_.sortBy(mappedOptions, m => m.label));
      setSelectedModality(null);
      setSelectedSubmodality(null);
    }
    fetchModality(radioValue);
  }, [radioValue]);

  useEffect(() => {
    async function fetchClauses() {
      setIsLoading(true);
      const { clauses } = await ClausesAPI.showClause(
        radioValue,
        selectedModality?.id,
        selectedSubmodality?.id
      );
      setGeneralCondition(clauses?.find(c => c?.type === 1));
      setParticularConditions(clauses?.filter(c => c?.type === 3));
      setSpecialCondition(clauses?.find(c => c?.type === 4 || c?.type === 2));
      setIsLoading(false);
    }
    if (selectedSubmodality) {
      fetchClauses();
    }
  }, [selectedSubmodality]);

  useEffect(() => {
    const mappedOptions = selectedModality?.subModalities.map(sub => ({
      label: sub.description,
      id: sub.id,
      value: sub.id
    }));
    setSelectedSubmodality(null);
    setSubOptions(_.sortBy(mappedOptions, m => m.label));
  }, [selectedModality]);

  const user = getUser();
  const handleCallbackMenu = (e, redirect) => {
    e.preventDefault();
    const isInvalidBrokerRegister =
      (e.target.id === 'painel-express' ||
        e.target.id === 'cotacao-emissao-Corretor' ||
        e.target.id === 'cotacao-emissao-Comercial' ||
        e.target.id === 'cotacao-emissao-Tomador') &&
      !remoteState.isSusepValidated &&
      remoteState.config.susepCheck;
    if (isInvalidBrokerRegister) {
      callbackMenu('invalidRegister');
    } else {
      window.location = redirect;
    }
  };

  async function downloadClause(clause) {
    const file = await ClausesAPI.downloadClause(clause.type, clause.id);
    const pdfFile = new Blob([file.data], { type: 'application/pdf' });
    const fileUrl = URL.createObjectURL(pdfFile);
    forceDownload(fileUrl, `${clause.title}.pdf`);
  }
  return (
    <>
      <NavigationMenu
        activeId="painel-processos"
        clickMenuCallback={handleCallbackMenu}
        data-testid="menu-clauses"
      />
      <StyledHeader data-testid="user-menu">
        {user && user.userName && <UserMenu user={user} />}
      </StyledHeader>
      <AlignItens data-testid="initial-clauses">
        <MainText>Bem-vindo,</MainText>
        <MiddleText>
          preencha as opções abaixo para{' '}
          <b>
            ver e baixar as <br /> condições padronizadas
          </b>{' '}
          disponíveis
        </MiddleText>
        <SmallerText>
          Selecione o <b>tipo de segurado</b>
          <StyledRadioButton
            onChange={() => setRadioValue(8)}
            checked={radioValue === 8}
          >
            Público
          </StyledRadioButton>
          <StyledRadioButton
            onChange={() => setRadioValue(9)}
            checked={radioValue === 9}
          >
            Privado
          </StyledRadioButton>
        </SmallerText>
        <SelectModality
          label="Selecione a modalidade"
          options={options}
          onChange={v => setSelectedModality(v)}
          value={selectedModality}
        />
        {selectedModality && (
          <SelectCoverage
            label="Selecione a cobertura"
            options={subOptions}
            onChange={v => setSelectedSubmodality(v)}
            value={selectedSubmodality}
          />
        )}
        <ClausesModal
          isOpen={modalOpen}
          closeModal={() => setModalOpen(false)}
          title="Condições contratuais padronizadas"
          generalCondition={generalCondition}
          particularConditions={particularConditions}
          specialCondition={specialCondition}
          handleDownload={downloadClause}
        />

        <Button
          data-testid="open-clauses-modal"
          variant="primary"
          size="big"
          label="Selecione a cobertura"
          onClick={() => setModalOpen(!modalOpen)}
          isLoading={isLoading}
          disabled={!selectedSubmodality}
        >
          Ver condições
        </Button>
      </AlignItens>
    </>
  );
}

ClausesWrapper.propTypes = {
  callbackMenu: PropTypes.func
};

export default ClausesWrapper;
